module.exports = __webpack_public_path__ + "static/media/battery.c807243a.svg";